import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isAuthenticated } from '@core/auth/kc-tokens';
import { ROUTES } from '../../app.routes';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  if (isAuthenticated()) return true;
  void router.navigate([ROUTES.login], { queryParams: { returnTo: state.url } });
  return false;
};
